"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef } from "react";
type Options = {
  volume?: number;
  src?: string;
};
export function useClickSound(t0) {
  const $ = _c(5);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    volume: t2,
    src: t3
  } = t1;
  const volume = t2 === undefined ? 0.2 : t2;
  const src = t3 === undefined ? "/audio/click.wav" : t3;
  const audioRef = useRef(null);
  let t4;
  if ($[2] !== src || $[3] !== volume) {
    t4 = () => {
      if (typeof window === "undefined") {
        return;
      }
      if (!audioRef.current) {
        const audio = new Audio(src);
        audio.volume = volume;
        audio.preload = "auto";
        audioRef.current = audio;
      }
      const audio_0 = audioRef.current;
      audio_0.currentTime = 0;
      audio_0.play().catch(_temp);
    };
    $[2] = src;
    $[3] = volume;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp() {}